import Env from '../../utils/Env';

export default {
    install: (app, options) => {
        app.config.globalProperties.$env = Env;
    }
}